import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import {AppDispatch} from '../App.store'
import {AppState} from '../App.reducer'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
